<template>
  <!-- <section> -->
  <el-form>
    <el-row style="margin-top: 10px" :gutter="5" :type="isMobile ? '' : 'flex'" justify="space-around">
      <!-- <el-row :gutter="5"> -->
      <!-- <el-col v-if="activeName == 1" :span="3">
        <el-form-item label="">
          <el-date-picker
                 :prefix-icon="isMobile ? '0' : ''"
               :editable="false"
            :clearable="false"
            style="width: 100%"
            v-model="filters.StartMonth"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="开始时间"
          ></el-date-picker>
        </el-form-item>
      </el-col> -->
      <el-col :span="3" :xs="12">
        <el-form-item label="" style="text-align: center">
          <el-switch v-model="filters.IsMoney" active-text="金额" inactive-text="片数"></el-switch>
        </el-form-item>
      </el-col>
      <el-col v-if="activeName == 1" :span="3" :xs="12">
        <el-form-item label="">
          <el-date-picker
            class="picker_cls"
            :prefix-icon="isMobile ? '0' : ''"
            :editable="false"
            :clearable="false"
            style="width: 100%"
            v-model="filters.EndMonth"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="月份"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col v-if="activeName == 2" :span="3" :xs="12">
        <el-form-item label="">
          <el-date-picker
            class="picker_cls"
            :prefix-icon="isMobile ? '0' : ''"
            :editable="false"
            :clearable="false"
            style="width: 100%"
            v-model="filters.Month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="月份"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col v-if="activeName == 3" :span="3" :xs="12">
        <el-form-item label="">
          <el-date-picker
            class="picker_cls"
            :prefix-icon="isMobile ? '0' : ''"
            :editable="false"
            :clearable="false"
            style="width: 100%"
            v-model="filters.StartDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col v-if="activeName == 3" :span="3" :xs="12">
        <el-form-item label="">
          <el-date-picker
            class="picker_cls"
            :prefix-icon="isMobile ? '0' : ''"
            :editable="false"
            :clearable="false"
            style="width: 100%"
            v-model="filters.EndDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col v-show="!roleName_list.includes('一线销售')" :span="3" :xs="12">
        <el-form-item>
          <el-cascader
            placeholder="区域"
            ref="cascaderHandle_qy"
            v-model="value_qy"
            :props="props"
            :options="area_list"
            @change="handleChange_qy"
            clearable
          ></el-cascader>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="2" :xs="12">
          <el-form-item>
            <el-select style="width: 100%" clearable v-model="filters.RegionId" @change="getRegionList" placeholder="大区">
              <el-option v-for="item in area_list" :key="item.id" :label="item.regionName" :value="item.regionId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-form-item>
            <el-select style="width: 100%" clearable v-model="filters.SubRegionId" placeholder="小区">
              <el-option v-for="item in city_list" :key="item.id" :label="item.subRegionName" :value="item.subRegionId"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
      <el-col :span="3" :xs="12">
        <el-form-item>
          <el-cascader
            placeholder="产品"
            ref="cascaderHandle_pl"
            v-model="value_pl"
            :props="props2"
            :options="product_List"
            @change="handleChange_pl"
            popper-class="cascader-pl"
            class="cascader-pl"
            clearable
            collapse-tags
          ></el-cascader>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="2" :xs="12">
          <el-form-item>
            <el-select style="width: 100%" @change="Getproductlistothers" clearable v-model="filters.Category" placeholder="品类">
              <el-option label="PC" value="PC"></el-option>
              <el-option label="MONO" value="MONO"></el-option>
              <el-option label="TORIC" value="TORIC"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item>
            <el-select style="width: 100%" clearable v-model="filters.ProductId" placeholder="产品编码">
              <el-option v-for="item in product_List" :key="item.code" :label="item.code" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
      <el-col :span="3" :xs="12">
        <el-form-item>
          <el-select style="width: 100%" clearable v-model="filters.TopHsp" placeholder="医院分级">
            <el-option label="Top 400" value="Top 400"></el-option>
            <el-option label="Next 800" value="Next 800"></el-option>
            <el-option label="Others" value="Others"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="3" :xs="12">
        <el-form-item>
          <!-- <el-select
              style="width: 100%"
              v-model="filters.KaGroup"
              filterable
              remote
              :remote-method="usagereport_getgroupnamedropdown_fn"
              ref="select3"
              clearable
              placeholder="集团名称"
            >
              <el-option v-for="(item, index) in groupnamedropdown_list" :label="item" :value="item"></el-option>
            </el-select> -->
          <el-select style="width: 100%" clearable v-model="filters.KaGroup" placeholder="集团名称">
            <el-option label="AIER 爱尔" value="AIER"></el-option>
            <el-option label="HX 华厦" value="HX"></el-option>
            <el-option label="PURUI 普瑞" value="PURUI"></el-option>
            <el-option label="CHAOJU 朝聚" value="CHAOJU"></el-option>
            <el-option label="HESHI 何氏" value="HESHI"></el-option>
            <el-option label="GZ 光正" value="GZ"></el-option>
            <el-option label="ZDGM 正大光明" value="ZDGM"></el-option>
            <el-option label="CMER 希玛" value="CMER"></el-option>
            <el-option label="SJGM 视界光明" value="SJGM"></el-option>
            <el-option label="MESEE 济南明水" value="MESEE"></el-option>
            <el-option label="Other Private" value="Other"></el-option>
          </el-select>
          <!-- <el-input v-model="filters.KaGroup" placeholder="KA集团名称"></el-input> -->
        </el-form-item>
      </el-col>
      <el-col :span="3" :xs="12">
        <el-form-item>
          <el-select style="width: 100%" clearable v-model="filters.HspType" placeholder="医院性质">
            <el-option label="公立" value="false"></el-option>
            <el-option label="私立" value="true"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="3" :xs="12">
        <el-form-item>
          <el-select
            style="width: 100%"
            v-model="filters.HospitalName"
            filterable
            @focus="clear('select_yy')"
            @hook:mounted="clear('select_yy')"
            @visible-change="clear('select_yy')"
            remote
            :remote-method="usagereport_gethospitaldropdown_fn"
            ref="select_yy"
            clearable
            placeholder="医院名称"
          >
            <el-option v-for="(item, index) in hospitaldropdown_list" :label="item" :value="item"></el-option>
          </el-select>
          <!-- <el-input v-model="filters.HospitalName" placeholder="医院名称"></el-input> -->
        </el-form-item>
      </el-col>
      <!-- <el-col v-show="!roleName_list.includes('一线销售')" :span="3" :xs="12">
        <el-form-item>
          <el-select
            style="width: 100%"
            v-model="filters.ID"
            filterable
            @focus="clear('select_xs')"
            @hook:mounted="clear('select_xs')"
            @visible-change="clear('select_xs')"
            remote
            :remote-method="usagereport_getsalesnamedropdown_fn"
            ref="select_xs"
            clearable
            placeholder="销售代表"
          >
            <el-option v-for="(item, index) in salesnamedropdown_list" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-col> -->
      <!-- <el-col :span="2" :xs="24">
          <el-form-item>
            <el-button style="width: 100%" type="primary" @click="getReportData(1)">查询</el-button>
          </el-form-item>
        </el-col> -->
    </el-row>
  </el-form>
  <!-- </section> -->
</template>

<script>
import {
  usagereport_gethospitaldropdown,
  usagereport_getsalesnamedropdown,
  usagereport_getgroupnamedropdown,
  usagereport_getproductlistothers,
} from '@/api/api'
import { calculateSum, loadings } from '@/utils'
export default {
  name: 'reprot_forms',
  data() {
    return {
      value_pl: [],
      value_qy: [],
      props: {
        value: 'regionId',
        label: 'regionName',
        children: 'subRegions',
        disabled: 'disabled',
        checkStrictly: true,
      },
      props2: {
        value: 'key',
        label: 'key',
        children: 'values',
        disabled: 'disabled',
        checkStrictly: false,
        multiple: true,
      },
      isMobile: false,
      hospitaldropdown_list: [],
      groupnamedropdown_list: [],
      salesnamedropdown_list: [],
      city_list: [],
      filters: {
        StartMonth: '',
        EndMonth: '',
        IsMoney: false,
        Month: '',
        StartDate: '',
        EndDate: '',
        RegionId: '',
        SubRegionId: '',
        Category: '',
        ProductId: '',
        ID: '',
      },
      titles_dia: '提示',
      CH_IF: true,
      dialogVisible: false,
      approval_obj: {
        approvedId: '',
        isApproved: '',
        reasonMessage: '',
      },
      request_list: [],
      description_text: '',
      num_zt: 0,
      watch_activeName: 0,
      product_List: [],
    }
  },
  props: ['activeName', 'area_list', 'roleName_list'],
  watch: {
    filters: {
      handler(newVal, oldVal) {
        this.getReportData()
      },
      deep: true,
    },
    area_list(res) {
      if (res.length == 1) {
        this.filters.RegionId = res[0].regionId
        this.getRegionList(res[0].regionId)
      }
    },
    // activeName: {
    //   handler(newVal, oldVal) {
    //     this.filters = {
    //       StartMonth: '',
    //       EndMonth: '',
    //       Month: '',
    //       Date: '',
    //       RegionId: '',
    //       SubRegionId: '',
    //     }
    //     if (newVal == 1) {
    //       //   this.filters.StartMonth = calculateSum(5)
    //       this.filters.EndMonth = calculateSum()
    //       this.getReportData()
    //     } else if (newVal == 2) {
    //       this.filters.Month = calculateSum()
    //       this.getReportData()
    //     } else if (newVal == 3) {
    //       this.filters.Date = calculateSum(1)
    //       this.getReportData()
    //     }
    //   },
    //   immediate: true,
    // },
  },
  computed: {},
  created() {
    this.Getproductlistothers()
    if (this.area_list.length == 1) {
      this.filters.RegionId = this.area_list[0].regionId
      this.getRegionList(this.area_list[0].regionId)
    }
    // this.filters = {
    //   StartMonth: '',
    //   EndMonth: '',
    //   Month: '',
    //   Date: '',
    //   RegionId: '',
    //   SubRegionId: '',
    // }
    if (this.activeName == 1) {
      //   this.filters.StartMonth = calculateSum(5)
      this.filters.EndMonth = calculateSum()
      //   this.getReportData()
    } else if (this.activeName == 2) {
      this.filters.Month = calculateSum()
      //   this.getReportData()
    } else if (this.activeName == 3) {
      this.filters.StartDate = calculateSum(1)
      this.filters.EndDate = calculateSum(1)
      //   this.getReportData()
    }
    this.isMobile = window.innerWidth <= 475
  },
  //   watch: {
  //     ApproveList() {
  //       this.ApproveListFn()
  //     },
  //   },
  methods: {
    clear(selectName) {
      this.$nextTick(() => {
        // ios 手机有延迟问题
        setTimeout(() => {
          const select3 = this.$refs[selectName]
          const input = select3.$el.querySelector('.el-input__inner')
          input.removeAttribute('readonly')
        }, 200)
      })
    },
    handleChange_pl(e) {
      const innerArray = e
      const index0Array = []
      const index1Array = []
      var Category_arr = []
      var ProductId_arr = []
      // 遍历收集元素
      for (const subArray of innerArray) {
        index0Array.push(subArray[0])
        if (subArray.length >= 2) {
          index1Array.push(subArray[1])
        }
      }
      // 去重
      Category_arr = [...new Set(index0Array)]
      ProductId_arr = [...new Set(index1Array)]
      this.filters.Category = Category_arr.join(',')
      this.filters.ProductId = ProductId_arr.join(',')
      //   if (e.length == 1) {
      //     this.filters.Category = e[0]
      //     this.filters.ProductId = ''
      //   } else if (e.length == 2) {
      //     this.filters.Category = e[0]
      //     this.filters.ProductId = e[1]
      //   } else {
      //     this.filters.Category = ''
      //     this.filters.ProductId = ''
      //   }
      //   this.$refs.cascaderHandle_pl.dropDownVisible = false
    },
    handleChange_qy(e) {
      if (e.length == 1) {
        this.filters.RegionId = e[0]
        this.filters.SubRegionId = ''
        this.filters.ID = ''
      } else if (e.length == 2) {
        this.filters.RegionId = e[0]
        this.filters.SubRegionId = e[1]
        this.filters.ID = ''
      } else if (e.length == 3) {
        this.filters.RegionId = e[0]
        this.filters.SubRegionId = e[1]
        this.filters.ID = e[2]
      } else {
        this.filters.RegionId = ''
        this.filters.SubRegionId = ''
        this.filters.ID = ''
      }
      this.$refs.cascaderHandle_qy.dropDownVisible = false
    },
    async Getproductlistothers(e) {
      const { data } = await usagereport_getproductlistothers({
        key: e,
      })
      this.product_List = data.data
    },
    async usagereport_gethospitaldropdown_fn(e) {
      const { data } = await usagereport_gethospitaldropdown({
        keyword: e,
      })
      this.hospitaldropdown_list = data
    },
    async usagereport_getgroupnamedropdown_fn(e) {
      const { data } = await usagereport_getgroupnamedropdown({
        keyword: e,
      })
      this.groupnamedropdown_list = data
    },
    async usagereport_getsalesnamedropdown_fn(e) {
      const { data } = await usagereport_getsalesnamedropdown({
        keyword: e,
      })
      this.salesnamedropdown_list = data
    },
    getReportData() {
      this.$emit('getReportData', this.filters)
    },
    getRegionList(value) {
      const selectedOptions = this.area_list.filter((option) => option.regionId === value)
      this.city_list = selectedOptions[0].subRegions
      if (this.city_list.length == 1) {
        this.filters.SubRegionId = selectedOptions[0].subRegions[0].subRegionId
      } else {
        this.filters.SubRegionId = ''
      }
    },
    linkProps(to) {
      if (this.isExternal) {
        return {
          href: to,
          target: '_blank',
          style: 'color:#fff;',
        }
      }
      return {
        to: to,
      }
    },
  },
}
</script>
<style>
.picker_cls .el-input__inner {
  padding-right: 0px !important;
}
.cascader-pl .el-tag {
  font-size: 8px !important;
}
</style>
